import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lyceoCssVar',
  standalone: true,
})
export class CssVarPipe implements PipeTransform {
  public transform(cssVar: string): string {
    return `var(--trix-${cssVar})`;
  }
}
